import React from 'react';
import { cn } from '../../lib/utils';

export const Button = React.forwardRef(({ 
  className, 
  variant = 'primary', 
  size = 'default',
  children,
  ...props 
}, ref) => {
  const variants = {
    primary: 'bg-primary text-white hover:bg-primary/90 shadow-[0_0_30px_-5px_rgba(99,102,241,0.5)] hover:shadow-[0_0_50px_-5px_rgba(99,102,241,0.8)] disabled:shadow-none disabled:bg-primary/70',
    secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
    outline: 'border border-slate-700 bg-transparent hover:bg-slate-800 text-white',
    ghost: 'hover:bg-slate-800 text-slate-300 hover:text-white'
  };

  const sizes = {
    default: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    sm: 'px-4 py-2 text-sm'
  };

  return (
    <button
      ref={ref}
      className={cn(
        'rounded-full font-semibold transition-all duration-300 hover:scale-105 active:scale-95 disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:scale-100',
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
});

Button.displayName = 'Button';
